import * as React from 'react'
import Spinner from '../components/Spinner'
import moment from 'moment/min/moment-with-locales'
import { Redirect } from 'react-router-dom'

class AddFishScreen extends React.Component {

  constructor(props) {
    super(props)

    //if isset props.location.fish -> editing existing fish obj
    if( props.location.fish ) {
      const { fishType, time, amount, price, fisherId, fishMarketId, timeOnMarket } = props.location.fish
      this.state = {
        id: fishMarketId,
        fishType: fishType,
        time: moment(time.seconds*1000).format("YYYY-MM-DDTHH:mm"),
        amount: amount,
        fisherId: fisherId,
        price: price,
        timeOnMarket: timeOnMarket ? timeOnMarket : 3
      }
    } else {
      this.state = {
        fishType: (props.fish.fishTypes && props.fish.fishTypes.length) ? props.fish.fishTypes[0].id : null,
        time: moment().add(3, 'hours').format("YYYY-MM-DDTHH:mm"),
        amount: null,
        fisherId: 0,
        price: null,
        timeOnMarket: 3
      }
    }
  }

  componentDidMount() {
    if( !this.props.users.userListWithType.fisherman )
      this.props.getUserListWithType('fisherman')
  }

  componentWillReceiveProps(nextProps) {
    if( nextProps.app.loading !== this.props.app.loading ) {



      this.setState({
        fishType: (this.props.fish.fishTypes && this.props.fish.fishTypes.length) ? this.props.fish.fishTypes[0].id : null,
        time: moment().add(3, 'hours').format("YYYY-MM-DDTHH:mm"),
        amount: null,
        fisherId: 0,
        price: null,
        timeOnMarket: 3
      })
      setTimeout( () => { this.props.appMessage('') }, 6000)
    }
  }

  deleteFish = (e) => {
    e.preventDefault()
    const newTime = moment().subtract(500, 'days').format("YYYY-MM-DDTHH:mm")
    this.setState({
      time: newTime
    }, () => {
      this.editFish()
    })
  }

  editFish = () => {
    const { fishType, time, amount, price, fisherId, id, timeOnMarket } = this.state
    let fishObj = { id,
                    fishType, 
                    amount: parseInt(amount, 10), 
                    fisherId, 
                    time: moment(time).toDate(),
                    price: parseInt(price, 10),
                    timeOnMarket: timeOnMarket
                  }
    this.props.editFishOnMarket(fishObj)
  }

  addFish = () => {
    const { fishType, time, amount, price, fisherId, timeOnMarket } = this.state
    let fishObj = { fishType, 
                    amount: parseInt(amount, 10), 
                    fisherId, 
                    time: moment(time).toDate(),
                    price: parseInt(price, 10),
                    timeOnMarket: parseInt(timeOnMarket, 10)
                  }
    this.props.addFishToMarket(fishObj)
  }

  addBtnDisabled() {
    const { fishType, time, amount, price, fisherId } = this.state
    if( fishType && time && amount && price && fisherId && fisherId!=='0' ) return false
    return true
  }

  render() {
    const { fishTypes } = this.props.fish
    
    if( this.props.app.loading ) return <Spinner />
    if( !this.props.users.userListWithType.fisherman ) return <Spinner />
    if( !this.props.users.userListWithType.fisherman.length ) return <div className="alert alert-danger">Uwaga: brak rybaków. Najpierw dodaj rybaka!</div>
    if( this.props.app.message==='{goToAddedFishList}') return <Redirect to="/manageapp/added-fish" />

    
    return (
      <div>
        { this.props.app.message.length>0 && <div className="alert alert-danger">{this.props.app.message}</div>}
        { this.state.id && <div className="alert alert-info">Edycja ryby dodanej na targ</div>}
        <form>

          <div className="form-group">
            <label>Wybierz rybaka</label>
            <select className="form-control" onChange={event => this.setState({ fisherId: event.target.value })} value={this.state.fisherId} >
              <option key='noselect' value={0}>Wybierz rybaka</option>
              {this.props.users.userListWithType.fisherman.map( (f, key) => <option key={key} value={f.id}>{f.firstName} {f.lastName} {f.email}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>Wybierz gatunek</label>
            <select className="form-control" onChange={event => this.setState({ fishType: event.target.value })} value={this.state.fishType} >
              {fishTypes.map( (f, key) => <option key={key} value={f.id} >{f.name}</option>)}
            </select>
          </div>
          
          { this.state.fishType!==null &&
          <React.Fragment>
            <div className="form-group">
              <label>Ilość</label>
              <div className="input-group">
                <input
                  type="number"
                  className="form-control" 
                  placeholder="Ilość" 
                  onChange={event=>this.setState({ amount: event.target.value })}
                  defaultValue={this.state.amount}
                />
                <div className="input-group-append">
                  <span className="input-group-text">{fishTypes.filter(f=>f.id===this.state.fishType)[0].amount.kg ? 'kg' : 'sztuk'}</span>
                </div>
              </div>
            </div>
            
            <div className="form-group">
              <label>Cena za {fishTypes.filter(f=>f.id===this.state.fishType)[0].amount.kg ? 'kilogram' : 'sztukę'}</label>
              <div className="input-group">
                <input 
                  type="number"
                  className="form-control" 
                  placeholder="Podaj cenę (tylko cyfry)"
                  onChange={event=>this.setState({ price: event.target.value })}
                  defaultValue={this.state.price}
                />
                <div className="input-group-append">
                  <span className="input-group-text">PLN</span>
                </div>
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="exampleInputEmail1">Kiedy na targu?</label>
              <input 
                type="datetime-local" 
                className="form-control"
                onChange={event=>this.setState({ time: event.target.value })}
                defaultValue={this.state.time}
              />
            </div>

            <div className="form-group">
              <label>Ile godzin na targu</label>
              <select className="form-control" onChange={event => this.setState({ timeOnMarket: event.target.value })} value={this.state.timeOnMarket} >
                {[1,2,3,4,5,6,7].map( (f, key) => <option key={key} value={f} >{f} godz.</option>)}
              </select>
            </div>
            

            {this.props.location.fish ?
              <React.Fragment>
              <button
                type="submit"
                className="btn btn-primary mt-2"
                disabled={ this.addBtnDisabled() }
                onClick={ this.editFish }
                >Edytuj
              </button>
              <button
                type="submit"
                className="btn btn-danger mt-2 ml-3"
                onClick={ this.deleteFish }
                >Usuń
              </button>
              </React.Fragment>
              :
              <button
              type="submit"
              className="btn btn-primary mt-2"
              disabled={ this.addBtnDisabled() }
              onClick={ this.addFish }
              >Dodaj
              </button>
            }
        </React.Fragment>
        }
        </form>
      </div>
    )
  }
}


export default AddFishScreen



// WEBPACK FOOTER //
// ./src/screens/AddFishScreen.js